// NOTES:
// - put more specific redirects first
// - use absolute paths to ensure no weird relative path behavior
const REDIRECTS = [
  { from: '/move', to: '/try/move', status: 301 },
  { from: '/nyc', to: '/try/new-york-city', status: 301 },
  { from: '/radio', to: '/try/radio', status: 301 },
  { from: '/summer', to: '/try/summer', status: 301 },
  // Deprecated live routes
  { from: '/purchase/live(/**)(/**)', to: '/', status: 301 },
  { from: '/signup/live(/**)(/**)', to: '/', status: 301 },
  // Deprecated angular routes
  { from: '/classes', to: '/search', status: 301 },
  { from: '/classes/refer', to: '/search', status: 301 },
  { from: '/classes/welcome', to: '/search', status: 301 },
  { from: '/studios', to: '/search', status: 301 },
];

export const asRedirectRoute = ({ from, to, stripQuery, status }) => ({
  path: from,
  onEnter: ({ location }, replace) =>
    replace({
      pathname: to,
      ...(!stripQuery && location.query && { query: location.query }),
      ...(status && { state: { status } }),
    }),
});

export default REDIRECTS.map(asRedirectRoute);
